const labels: Record<string, string> = {
  title: 'Titel', subtitle: 'Untertitel', teaser: 'Teaser für Social-Media', content: 'Artikeltext',
  topic: 'Thema', tags: 'Tags', seoTitle: 'Meta-Titel', metaDescription: 'Meta-Beschreibung',
  'author.name': 'Autor', 'category.name': 'Kategorie', 'dossier.title': 'Dossier',
  'image.caption': 'Bildunterschrift', 'image.prompt': 'Bild-Prompt', 'image.source': 'Bildquelle'
};

// ChromeDriver's send_keys cannot type supplementary Unicode characters.
// Keep the saved text intact; stop before creating a publication request.
export function assertPublicationCompatibleText(payload: unknown): void {
  const visit = (value: unknown, path: string) => {
    if (typeof value === 'string') {
      for (const character of Array.from(value)) {
        const point = character.codePointAt(0)!;
        if (point > 0xffff || (point >= 0xd800 && point <= 0xdfff)) {
          const code = `U+${point.toString(16).toUpperCase()}`;
          throw new Error(`Im Feld „${labels[path.replace(/\[\d+\]$/, '')] || path}“ steht ein nicht unterstütztes Zeichen (${code}${point > 0xffff ? `: ${character}` : ''}). Bitte entferne oder ersetze es vor dem Einreichen. Deine Eingaben wurden nicht verändert.`);
        }
      }
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => visit(item, `${path}[${index}]`));
    } else if (value && typeof value === 'object') {
      Object.entries(value).forEach(([key, item]) => visit(item, path ? `${path}.${key}` : key));
    }
  };
  visit(payload, '');
}
